import type { WebpImageName } from '@/types/_webp'

export const VIP_LEVEL_NAME_KEY_MAP: Record<number, string> = {
  1: '青铜',
  2: '白银',
  3: '黄金',
  4: '铂金',
  5: '钻石'
}

const VIP_LEVEL_IMAGE_MAP: Record<number, WebpImageName> = {
  1: 'imgs/vip/vip_tier_bronze.webp',
  2: 'imgs/vip/vip_tier_silver.webp',
  3: 'imgs/vip/vip_tier_gold.webp',
  4: 'imgs/vip/vip_tier_platinum.webp',
  5: 'imgs/vip/vip_tier_diamond.webp'
}

export const getVipLevelNameKey = (level?: number) => {
  const safeLevel = Number(level)
  return VIP_LEVEL_NAME_KEY_MAP[safeLevel]
}

export const getVipLevelImage = (level?: number): WebpImageName | undefined => {
  const safeLevel = Number(level)
  return VIP_LEVEL_IMAGE_MAP[safeLevel]
}
